import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { RiDeleteBin6Line } from "react-icons/ri";
import { ButtonLoader } from "../Loader.js";
import { SrxApi } from "../../api/SrxApi";
import { toast } from "react-toastify";

const DeleteModal = ({
  isDeleteModalOpen,
  setIsDeleteModalOpen,
  url,
  onDeleteSuccess = null,
  refetchData,
}) => {
  const [loading, setLoading] = useState(false);


  const handleClose = () => {
    setIsDeleteModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await SrxApi.delete(url);
      setIsDeleteModalOpen(false);
      setLoading(false);
      handleClose();
      refetchData();
      toast.success("Item deleted successfully");
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Failed to delete item");
    }
  };

  return (
    <Modal isOpen={isDeleteModalOpen} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose} className="border-bottom-0 pb-0">
        <h5 className="mb-0 font-weight-bold" style={{ fontSize: "18px", color: "black" }}>Delete Item</h5>
      </ModalHeader>
      <hr style={{ margin: "0px" }} />
      <ModalBody className="pt-3">
        <div className="d-flex align-items-start gap-3">
          <div className="d-flex align-items-center justify-content-center" style={{ minWidth: "60px" }}>
            <div style={{
              width: "60px",
              height: "60px",
              backgroundColor: "#ee2957",
              background: "linear-gradient(135deg, #ec0e42 0%, #FFC3D6 100%)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#ffc0cb",
                  background: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)"
                }}
              >
                <RiDeleteBin6Line style={{ fontSize: "28px", color: "#dc3545" }} />
              </div>
            </div>
          </div>
          <div className="flex-grow-1 d-flex flex-column gap-2 ml-2">
            <h5 className=" font-weight-bold" style={{ fontSize: "16px", color: "black", marginBottom: "0" }}>Delete Item</h5>
            <p className="text-muted mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
              Are you sure you want to delete this item? This action cannot be undone.
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="border-top-0 pt-0">

        <Button
          color="gray"
          onClick={handleClose}
          disabled={loading}
          style={{ cursor: "pointer", border: "1px solid #E5E7EB", borderRadius: "5px", padding: "10px 20px", color: "#6B7280" }}
          className="btn-sm"
        >
          Cancel
        </Button>

        <Button
          color="danger"
          onClick={handleConfirmDelete}
          disabled={loading}
          style={{ cursor: "pointer", borderRadius: "5px", padding: "10px 20px", color: "white", border: "none" }}
        >
          {loading ? <ButtonLoader /> : "Delete"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
